import * as z from 'zod';

export const ownedSkillSchema = z.object({
  skillId: z.number(),
  skillName: z.string(),
  level: z.number()
});

export const ownedSkillsSchema = z.array(ownedSkillSchema);
export type OwnedSkills = z.infer<typeof ownedSkillsSchema>;
